/**
 * UserFallbackIcon Component
 *
 * Generic person silhouette used when a user has no avatar_url.
 * Originally inline in SalesOrderTable; extracted so other tables
 * (price modifiers, etc.) render owner cells the same way.
 */

export function UserFallbackIcon({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <path
        d="M16.667 35.833H43.333C47.0902 35.833 50.6938 37.3258 53.3506 39.9824C56.0073 42.6392 57.5 46.2428 57.5 50C57.5 51.9891 56.7102 53.8972 55.3037 55.3037C53.8972 56.7102 51.9891 57.5 50 57.5H10C8.01087 57.5 6.10281 56.7102 4.69629 55.3037C3.28977 53.8972 2.5 51.9891 2.5 50C2.5 46.2428 3.99265 42.6392 6.64941 39.9824C9.30616 37.3258 12.9098 35.833 16.667 35.833ZM30 2.5C32.8731 2.5 35.6285 3.64131 37.6602 5.67285C39.6917 7.70442 40.8329 10.4599 40.833 13.333C40.833 16.2062 39.6918 18.9625 37.6602 20.9941C35.6285 23.0256 32.873 24.167 30 24.167C27.127 24.167 24.3715 23.0256 22.3398 20.9941C20.3082 18.9625 19.167 16.2062 19.167 13.333C19.1671 10.4599 20.3083 7.70442 22.3398 5.67285C24.3715 3.64131 27.1269 2.5 30 2.5Z"
        stroke="currentColor"
        strokeWidth="5.625"
      />
    </svg>
  );
}
